<template>
    <div id="recent_assets">
      
      <m-p-asset-menu-header
         :title="getTitle"
         :isSearch="isSearch"
         :upload="currSelectedAssetType !== 6 && currSelectedAssetType !== 10 && currSelectedAssetType !== 8"
         @uploadClicked="uploadClicked"
      ></m-p-asset-menu-header>

      <media-upload-area
         v-if="showUploadArea"
      ></media-upload-area>
      
      <div id="recent_asset_container" class="asset-wrapper">
            <div v-if="assets.length === 0" class="no-assets">
               <span v-if="currSelectedAssetType !== 6">No {{getAssetString(currSelectedAssetType)}} assets. Assign some assets to this channel.</span>
               <span v-else>No feeds. Assign some feeds to this channel.</span>
            </div> 
            <div v-if="currSelectedAssetType != 3 && currSelectedAssetType != 8" >
               <div ref="asset_row'" class="asset-row" v-for="i in rowCount" :key="i">
                  <m-p-asset
                     v-for="(asset, index) in assetCountInRow(i)"
                     :key="asset.recid"
                     :asset="asset"
                     :index="index"
                     :playingIndex="audioPlayingIndex"
                     @play="handlePlay" 
                     @pause="handlePause"
                  ></m-p-asset>
               </div>
            </div>
            <div v-else-if="currSelectedAssetType == 3">
               <m-p-audio-asset
                  v-for="(asset, index) in assets"
                  :key="asset.recid"
                  :asset="asset"
                  :index="index"
                  :playingIndex="audioPlayingIndex"
                  @play="handlePlay" 
                  @pause="handlePause"
               ></m-p-audio-asset>
            </div>
            <div v-else-if="currSelectedAssetType == 8">
               <m-p-weblink-asset
                  v-for="(asset, index) in assets"
                  :key="asset.recid"
                  :asset="asset"
               ></m-p-weblink-asset>
            </div>

            <div v-if="recentMore" class="show-more-container">
               <div class="show-more-text" @click="showMore">Show More</div>
            </div>
      </div>
   </div>
</template>

<script>
import MPAssetMenuHeader from './MPAssetMenuHeader';
import MPAsset from './MPAsset';
import MPAudioAsset from './MPAudioAsset';
import MediaUploadArea from './MediaUploadArea';
import BaseMPAssets from './BaseMPAssets';
import MPWeblinkAsset from './MPWeblinkAsset';
import {Draggable, Droppable, Sortable, Swappable} from '@shopify/draggable';


import { mapActions, mapState } from 'vuex';

export default {
   extends: BaseMPAssets,

   data() {
      return {
         filteredAssets: [],
         isSearch: false,
         showUploadArea: false,
      }
   },

   props: {
      enterSearch: Boolean,
      searchKeyword: String,
      searchTrigger: Boolean,
   },

   computed: {
      ...mapState('global', [
         'mpRecentAssets',
         'isLoadingRecent',
         'recentMore',
         'mpRecentPage',
         'currSearchTerm',
         'currSelectedCategory',
         'currSelectedAssetType'
      ]),

      assets() {
         return this.mpRecentAssets;
      },

      getTitle() {
         if (!this.enterSearch) {
            return 'RECENTLY ADDED';
         } else {
            return this.searchKeyword;
         }
      },

      moreToShow() {
         return this.recentMore;
      },

      isLoading() {
         return this.isLoadingRecent
      }
   },

   created() {
      let self = this;
      this.$on('Ingested', () => {
         self.getAssets();
      });
   },

   methods: {
      ...mapActions('global', ['fetchRecentMedia', 'resetUpload']),

      getAssets(refresh=false) {
         this.fetchRecentMedia({ vm: this, refresh });
         //get the assets
         // let self = this;
         // $.post(
         //    this.BARD_HOST + '/' + this.getAssetString(this.assetType) + '/recent',
         //    {
         //       'token'      : localStorage.getItem('token'),
         //       'limit' : 20,
         //       'page': self.page,
         //       'channelRecid' : this.channelRecid != undefined ? this.channelRecid: 0,
         //       'isScoreboard' : this.isScoreboard,
         //       'categoryRecid': this.sortByCategory
         //    }, function(data) {
         //       if (!data.error) {
         //          if (data.length < 20) {
         //             self.moreToShow = false;
         //          } else {
         //             self.moreToShow = true;
         //          }
         //          if (self.page > 1) {
         //             self.assets = self.assets.concat(data);
         //          } else {
         //             self.assets = data;
         //          }
         //       } else {
         //          self.handleFailedAPICall('/' + this.getAssetString(this.assetType) + '/recent', 'MPRecentAssets', data);
         //       }
         //    }
         // ).fail(function(e) {
         //    console.log("Error with " + self.getAssetString(this.assetType) + "/recent/: " + e.responseText);
         // }); 
      },

      afterIngest() {
         this.getAssets();
      },

      uploadClicked() {
         this.showUploadArea = !this.showUploadArea;
         if (!this.showUploadArea) {
            this.resetUpload();
         }
      },

      // getAssetsByCategory() {
      //    let self = this;
      //    $.post(
      //       this.BARD_HOST + '/' + this.getAssetString(this.currSelectedAssetType) + '/category/' + this.sortByCategory,
      //       {
      //          'token'      : localStorage.getItem('token'),
      //          'limit' : 20,
      //          'page' : this.page,
      //          'channelRecid' : this.channelRecid != undefined ? this.channelRecid: 0
      //       }, function(data) {
      //          if (!data.error) {
      //             if (data.length < 20) {
      //                self.moreToShow = false;
      //             } else {
      //                self.moreToShow = true;
      //             }
      //             if (self.page > 1) {
      //                self.assets = self.assets.concat(data);
      //             } else {
      //                self.assets = data;
      //             }
      //          } else {
      //             self.handleFailedAPICall('/' + this.getAssetString(this.currSelectedAssetType) + '/category/' + this.sortByCategory, 'MPRecentAssets', data);
      //          }
      //       }
      //    ).fail(function(e) {
      //       console.log("Error with " + self.getAssetString(this.currSelectedAssetType) + "/category/" + self.sortByCategory + ": " + e.responseText);
      //    });
      // },

      // getAssetsBySearch() {
      //    let self = this;
      //    $.post(
      //       this.BARD_HOST + '/media/search',
      //       {
      //          'token'      : localStorage.getItem('token'),
      //          'assetType' : this.currSelectedAssetType,
      //          'searchString' : this.searchKeyword,
      //          'limit' : 20,
      //          'page': this.page,
      //          'channelRecid' : this.channelRecid != undefined ? this.channelRecid: 0,
      //          'categoryRecid': this.sortByCategory != undefined ? this.sortByCategory: 0
      //       }, function(data) {
      //          if (!data.error) {
      //             if (data.length < 20) {
      //                self.moreToShow = false;
      //             } else {
      //                self.moreToShow = true;
      //             }
      //             if (self.page > 1) {
      //                self.assets = self.assets.concat(data);
      //             } else {
      //                self.assets = data;
      //             }
      //          } else {
      //             self.handleFailedAPICall('/media/search', 'MPRecentAssets', data);
      //          }
      //    }).fail((e) => {
      //       console.log('Error with /media/search: ' + e.responseText);
      //    }); 
      // }
   },

   watch: {

      enterSearch() {
         this.showUploadArea = false;
         this.page = 0;
         if (this.searchKeyword !== '') {
            //filter based on search
            this.getAssetsBySearch();

            this.isSearch = true;
         } else {
            this.isSearch = false;
            this.getAssets();
         }
      },

      searchTrigger() {
         this.getAssetsBySearch();
      },
   },

   components: {
      MPAssetMenuHeader,
      MPAsset,
      MediaUploadArea,
      MPWeblinkAsset,
      MPAudioAsset
   }
}
</script>
